import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import StickyNavbar from "@/components/StickyNavbar";
import KineticHero from "@/components/KineticHero";
import EditorialTicker from "@/components/EditorialTicker";
import AboutManifesto from "@/components/AboutManifesto";
import ServicesGrid from "@/components/ServicesGrid";
import WhyChooseUs from "@/components/WhyChooseUs";
import ProjectsGallery from "@/components/ProjectsGallery";
import TestimonialsCarousel from "@/components/TestimonialsCarousel";
import QuoteContact from "@/components/QuoteContact";
import FaqSection from "@/components/FaqSection";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="bg-[#FAFAFA] text-neutral-900 antialiased overflow-x-clip">
            <Toaster position="top-center" richColors />
            <StickyNavbar />
            <main>
                <KineticHero />
                <EditorialTicker />
                <AboutManifesto />
                <ServicesGrid />
                <WhyChooseUs />
                <ProjectsGallery />
                <TestimonialsCarousel />
                <QuoteContact />
                <FaqSection />
            </main>
            <Footer />
            <BackToTop />
        </div>
    );
}

export default App;
